import "./SelectList.css";

/**
 * Scrollable highlight-to-select list.
 * Props:
 *   items       — array of { id, name, acct_num? }
 *   selectedIds — array of selected ids, or null (= all selected)
 *   onToggle    — fn(id) called when an item is clicked
 *   height      — max-height of the list (default "220px")
 */
export default function SelectList({ items, selectedIds, onToggle, height = "220px" }) {
  const allSelected = selectedIds === null;

  return (
    <div className="select-list" style={{ maxHeight: height }}>
      {items.map(item => {
        const active = allSelected || selectedIds.includes(item.id);
        const label = item.acct_num
          ? `${item.acct_num} ${item.name.includes(':') ? item.name.split(':').pop().trim() : item.name}`
          : (item.name.includes(':') ? item.name.split(':').pop().trim() : item.name);
        return (
          <div
            key={item.id}
            className={`select-list-item${active ? " selected" : ""}`}
            onClick={() => onToggle(item.id)}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
}
